import React from 'react';
import { SitecoreContext, SitecoreContextFactory } from '@sitecore-jss/sitecore-jss-react';
import { Route, Switch } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import componentFactory from './temp/componentFactory';
import RouteHandler from './RouteHandler';
import { Suspense } from "react";
import { toast, ToastContainer } from 'react-toastify';
import { VehicleCardsScrollContext } from "./hooks/VehicleCardsScrollContext";
import "react-toastify/dist/ReactToastify.css";
//import PfeIcon from '@patternfly/pfe-icon-iveco';
import ScrollToTop from './react-only-components/ScrollToTop/scrollToTop';
import { useEffect, useCallback } from "react";
// This is the main JSX entry point of the app invoked by the renderer (server or client rendering).
// By default the app's normal rendering is delegated to <RouteHandler> that handles the loading of JSS route data.

// support languages in the URL prefix
// e.g. /da-DK/path, or /en/path, or /path
export const routePatterns = [
  '/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*',
  '/:lang([a-z]{2})/:sitecoreRoute*',
  '/:sitecoreRoute*',
];

// wrap the app with:
// ApolloProvider: provides an instance of Apollo GraphQL client to the app to make Connected GraphQL queries.
//    Not needed if not using connected GraphQL.
// SitecoreContext: provides component resolution and context services via withSitecoreContext
// Router: provides a basic routing setup that will resolve Sitecore item routes and allow for language URL prefixes.
class AppRoot extends React.Component<any, any> {
  constructor(props) {
    super(props);

    //debugger;
    //   let customElements = window.customElements;
    //   customElements.whenDefined("pfe-icon").then( function() {
    //     const PfeIcon = customElements.get("pfe-icon");
    //     const setName = "ivg";
    //     //const newSetPath = "https://eucomcrg04-123710-cd.azurewebsites.net/corporate/sitecore/media library/Onhighwayicons/ivg-icons";

    //   //  let newSetPath ="https://eucomcrg04-123710-cd.azurewebsites.net/corporate/-/media/Onhighwayicons/ivg-icons";
    //  let newSetPath =
    //   "/-/media/Onhighwayicons/ivg-icons"

    //     // function to return the complete path of the icon
    //     function newResolveNameFn(iconName, setName, path) {
    //         return `${path}/${iconName}.svg`;
    //     }
    //     PfeIcon.addIconSet(setName, newSetPath, newResolveNameFn);

    //     PfeIcon.defaultThemeSetInfo = {path: newSetPath, resolveIconName: newResolveNameFn};

    //     // do what you need with the class here
    //   });

    this.state = {
      ssrRenderComplete: false,
      contextFactory: new SitecoreContextFactory(),
      vcScroll: false,
    };

    if (props.ssrState && props.ssrState.sitecore && props.ssrState.sitecore.route) {
      // set the initial sitecore context data if we got SSR initial state
      this.state.contextFactory.setSitecoreContext({
        route: props.ssrState.sitecore.route,
        itemId: props.ssrState.sitecore.route.itemId,
        ...props.ssrState.sitecore.context,
      });
    } else if (props.ssrState) {
      this.state.contextFactory.setSitecoreContext(props.ssrState.sitecore.context);
    } else {
      this.state.contextFactory.setSitecoreContext(null);
    }
  }

  setSsrRenderComplete = (ssrRenderComplete) =>
    this.setState({
      ssrRenderComplete,
    });

  setVcScroll = (v: boolean) => this.setState({ vcScroll: v });

  render() {
    const { path, Router, graphQLClient } = this.props;

    const routeRenderFunction = (props) => (
      <RouteHandler
        route={props}
        ssrRenderComplete={this.state.ssrRenderComplete}
        setSsrRenderComplete={this.setSsrRenderComplete}
      />
    );
    if (typeof window !== "undefined") {
        setTimeout(() => {
          document.querySelectorAll("meta[content]").forEach((element) => {

            if (element.getAttribute("content").length === 0) {
                element.setAttribute("content", window.location.href);
            }
          })

          document.querySelectorAll("link[rel='canonical']").forEach((element) => {

            if (element.getAttribute("href").length === 0) {
                element.setAttribute("href", window.location.href);
            }
          })
        }, 300);
      }
    return (
      <ApolloProvider client={graphQLClient}>
         <VehicleCardsScrollContext.Provider
          value={{ vcScroll: this.state.vcScroll, setVcScroll: this.setVcScroll }}
        >
        <SitecoreContext
          componentFactory={componentFactory}
          contextFactory={this.state.contextFactory}
        >
          <Suspense fallback={<div></div>}>
            <ToastContainer />
            <Router location={path} context={{}}>
              {/* <ScrollToTop /> */}
              <Switch>
                {routePatterns.map((routePattern) => (
                  <Route key={routePattern} path={routePattern} render={routeRenderFunction} />
                ))}
              </Switch>
            </Router>
          </Suspense>
        </SitecoreContext>
        </VehicleCardsScrollContext.Provider>
      </ApolloProvider>
    );
  }
}

export default AppRoot;
